/** PHP declaration defaults and positional/ref argument conventions. */
import type { PhpRef } from '../../port-contract';
export type DependencyName = "FateTideRedis::redis_ephemeral_set_json" | "FateTideRedis::redis_get" | "FateTideRedis::redis_invalidate" | "FateTideRedis::redis_set" | "Skill::getVariableName" | "StatusEffect::getQuantityInfo" | "StatusEffect::resolveQuantityAlias" | "ability_entry_current_charges" | "ability_entry_id" | "add_charges_to_ability" | "adjust_charges" | "advance_turn_if_dying_creatures_turn" | "apply_death_effect" | "apply_maimed_status" | "apply_persistent_aoe_to_encounter" | "apply_status_effect" | "campaign_arr_has_active_house_rule_type" | "campaign_field" | "campaign_time_to_seconds" | "change_inventory_charges" | "check_ability_conditions" | "check_other_status_effect_specials" | "check_status_effect_and_delete_single_connected_id" | "check_uuid" | "computed_value" | "creature_body_vanishes_active" | "creature_payload_statuses" | "creature_statuses" | "destroy_creature" | "discern_variable_tags" | "display_warning" | "drop_target_equipped_in_hand_inventory" | "encounter_creature_field" | "encounter_field" | "encounter_read_creature" | "error_log" | "extract_encounter_creature_arrs_to_encounter_creature_surface_arr" | "fetch_encounter_creatures" | "fetch_statuses" | "finalize_creature_arr" | "fire_target_loses_status_effect_triggers" | "ft_bake_castable_into_blob" | "ft_campaign_clock_to_minutes" | "ft_campaign_context" | "ft_campaign_light_for_clock" | "ft_campaign_season_transition_minutes_base" | "ft_campaign_sun_transition_minutes" | "ft_combat_truth_contingencies_shape" | "ft_combat_truth_member_scalars" | "ft_combat_truth_snapshot" | "ft_combat_truth_status_entry" | "ft_combat_truth_verdict_shape" | "ft_contingency_arm_authorize" | "ft_contingency_claim_status" | "ft_contingency_parse_condition" | "ft_contingency_refund_mana" | "ft_corpse_body_world_position" | "ft_corpse_consume_body" | "ft_corpse_inventory_for_creature" | "ft_corpse_publish_creature_position" | "ft_corpse_sync_creature_row" | "ft_creature_matches_active_combat" | "ft_ec_mark_derived_refresh_dirty" | "ft_enc_pos_sidecar_write_encounter" | "ft_encounter_context" | "ft_encounter_context_for_write" | "ft_encounter_id_is_depth_authored" | "ft_encounter_roster_row_ref" | "ft_entry_restore_item_arr" | "ft_fetch_all_active_contingency_triggers_for_encounter" | "ft_fetch_meshes_for" | "ft_finalize_item_arr_post" | "ft_ground_collision_diameter_ft" | "ft_inc_action_patch_after_row_write" | "ft_inc_move_patch_after_row_write" | "ft_layer_entry_needs_resolve" | "ft_lean_status_entry" | "ft_legacy_hit" | "ft_meshes_compile_enabled" | "ft_normalize_combat_id" | "ft_normalize_layer_entries_to_distinct_uuids" | "ft_opportunity_attack_client_input" | "ft_perm_encounter_for" | "ft_reseed_vitality_from_authority" | "ft_resolve_layer_entry" | "ft_skip_server_rule" | "ft_spell_is_level_upcastable" | "ft_status_item_passive_entries" | "ft_status_target_unset" | "ft_status_trigger_listeners_shape" | "ft_swarm_shed" | "ft_trap_apply_rearm_timer" | "ft_trap_arm" | "ft_trap_armed_status_row" | "ft_trap_consume_armed_state" | "ft_trap_fire_payload_interaction_matches" | "ft_trap_is_armed" | "ft_trap_mounted_ability_ids" | "ft_trap_place_zone" | "ft_trap_remove_zones" | "ft_trap_reset_interval_arr" | "ft_trap_reset_is_timed" | "ft_trap_status_row_ends_sortable" | "ft_trap_timed_trigger_not_fired" | "ft_trap_try_lazy_timed_resolution" | "ft_trapped_status_id" | "get_encounter_creature_arr" | "get_encounter_creature_permissions" | "get_inventory_arr" | "get_status_effect_duration_times" | "handle_summon_tag_status_effect" | "has_status_effect" | "insert_log_message" | "insert_massive_damage_instant_death_log_message" | "inventory_field" | "is_animated_summon" | "is_creature_not_a_summon" | "is_target_encounter_format" | "item_field" | "janus_attack_ability_context_arr" | "janus_nested_attack_ability_overlaps_passive_add_charges" | "janus_trigger_auto_place_aoe" | "janus_trigger_carrier_entries" | "janus_trigger_carriers" | "k4ActiveCombatColumn" | "k4CombatsTable" | "kill_creature" | "layer_entries" | "layer_has" | "layer_list_entry_uuid" | "layer_value" | "log_consciousness" | "lost_shapeshift" | "ordinal" | "passive_ability_entry_is_active" | "pl_cost_layer_entry_uuid" | "pl_total" | "pos_coord" | "process_affected_ids" | "process_dynamic_layers" | "publishToRedis" | "query_charges" | "query_d_item_arr" | "query_encounter_arr" | "query_encounter_creature_arr" | "query_full_item_arr" | "query_player_character_arr" | "register_shutdown_function" | "remove_recovery_and_dying_states" | "remove_stackable_status_effect_item_id_single_connection" | "remove_status_effect_item_id_single_connection" | "remove_status_effect_status_id_all_connections_to_all_targets" | "remove_status_effects" | "search_encounter_arr_for_item_arr" | "set_pos_coord" | "set_roll_by_arr_to_campaign_gm" | "soft_delete_encounter_creature" | "update_campaign_and_encounters_light" | "update_encounter_creature_stats" | "update_inventory_stats" | "update_status_effect_stats" | "v_status_id_of" | "valid_uuid";
export const signatures: Record<DependencyName, readonly { name: string; ref: boolean; default?: unknown }[]> = {
  "FateTideRedis::redis_ephemeral_set_json": [
    {
      "name": "args",
      "ref": false
    }
  ],
  "FateTideRedis::redis_get": [
    {
      "name": "args",
      "ref": false
    }
  ],
  "FateTideRedis::redis_invalidate": [
    {
      "name": "args",
      "ref": false
    }
  ],
  "FateTideRedis::redis_set": [
    {
      "name": "args",
      "ref": false
    }
  ],
  "Skill::getVariableName": [
    {
      "name": "itemId",
      "ref": false
    }
  ],
  "StatusEffect::getQuantityInfo": [
    {
      "name": "itemId",
      "ref": false
    }
  ],
  "StatusEffect::resolveQuantityAlias": [
    {
      "name": "itemId",
      "ref": false
    }
  ],
  "ability_entry_current_charges": [
    {
      "name": "entry",
      "ref": false
    },
    {
      "name": "caster_arr",
      "ref": false
    },
    {
      "name": "default",
      "ref": false,
      "default": "NA"
    }
  ],
  "ability_entry_id": [
    {
      "name": "entry",
      "ref": false
    }
  ],
  "add_charges_to_ability": [
    {
      "name": "used_ability_arr",
      "ref": false
    },
    {
      "name": "caster_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "use_ability_variable_1",
      "ref": false,
      "default": null
    }
  ],
  "adjust_charges": [
    {
      "name": "caster_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "item_id",
      "ref": false
    },
    {
      "name": "adjust_charge_qty",
      "ref": false
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    },
    {
      "name": "log_message",
      "ref": false,
      "default": false
    },
    {
      "name": "actual_debit",
      "ref": true,
      "default": null
    }
  ],
  "advance_turn_if_dying_creatures_turn": [
    {
      "name": "dying_creature_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "apply_death_effect": [
    {
      "name": "caster_arr",
      "ref": false
    },
    {
      "name": "target_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "status_connected_id",
      "ref": false
    },
    {
      "name": "custom_message",
      "ref": false,
      "default": "creature_killed"
    },
    {
      "name": "item_id_used",
      "ref": false,
      "default": ""
    },
    {
      "name": "body_vanishes",
      "ref": false,
      "default": false
    }
  ],
  "apply_maimed_status": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    }
  ],
  "apply_persistent_aoe_to_encounter": [
    {
      "name": "item_id_used_arr",
      "ref": false
    },
    {
      "name": "caster_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "status_connected_id",
      "ref": true
    },
    {
      "name": "encounter_arr",
      "ref": true
    },
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "status_casting_targets_arr",
      "ref": true
    },
    {
      "name": "use_ability_variable_1",
      "ref": false,
      "default": null
    },
    {
      "name": "continue_use_ability_logic",
      "ref": false,
      "default": true
    },
    {
      "name": "spell_counterspelled",
      "ref": false,
      "default": false
    },
    {
      "name": "paoe_follows_carrier_id",
      "ref": true,
      "default": null
    }
  ],
  "apply_status_effect": [
    {
      "name": "status_connected_id",
      "ref": false
    },
    {
      "name": "status_caster_arr",
      "ref": false
    },
    {
      "name": "status_target_arr",
      "ref": true
    },
    {
      "name": "status_casting_targets_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "status_origin_id",
      "ref": false
    },
    {
      "name": "status_item_id",
      "ref": false
    },
    {
      "name": "status_ends",
      "ref": false
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": ""
    },
    {
      "name": "log_message",
      "ref": false,
      "default": true
    },
    {
      "name": "unique_log_message",
      "ref": false,
      "default": "status_effect_applied"
    },
    {
      "name": "status_private",
      "ref": false,
      "default": 0
    },
    {
      "name": "log_overlay_item_id_used_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "status_aoe_source",
      "ref": false,
      "default": 0
    },
    {
      "name": "status_opposing_team_only",
      "ref": false,
      "default": 0
    },
    {
      "name": "status_paused_campaign",
      "ref": false,
      "default": null
    },
    {
      "name": "has_duration",
      "ref": false,
      "default": false
    },
    {
      "name": "bypass_immunity",
      "ref": false,
      "default": false
    },
    {
      "name": "campaign_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "status_shapeshift_monster_template_id",
      "ref": false,
      "default": null
    },
    {
      "name": "allow_duplicate_status_item_id",
      "ref": false,
      "default": false
    },
    {
      "name": "suppress_status_side_effects",
      "ref": false,
      "default": false
    },
    {
      "name": "status_stack",
      "ref": false,
      "default": 0
    },
    {
      "name": "status_aoe_geometry",
      "ref": false,
      "default": null
    }
  ],
  "campaign_arr_has_active_house_rule_type": [
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "campaign_house_rule_type_id",
      "ref": false
    }
  ],
  "campaign_field": [
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "key",
      "ref": false
    }
  ],
  "campaign_time_to_seconds": [
    {
      "name": "campaign_time",
      "ref": false
    }
  ],
  "change_inventory_charges": [
    {
      "name": "inventory_arr",
      "ref": false
    },
    {
      "name": "caster_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "change_charges_to",
      "ref": false
    },
    {
      "name": "log_message",
      "ref": false,
      "default": false
    }
  ],
  "check_ability_conditions": [
    {
      "name": "ability_arr",
      "ref": false
    },
    {
      "name": "item_arr",
      "ref": false
    },
    {
      "name": "template_creature",
      "ref": false,
      "default": false
    },
    {
      "name": "defer_skill_tier_requirements",
      "ref": false,
      "default": false
    }
  ],
  "check_other_status_effect_specials": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "target_status_effect_value",
      "ref": false
    },
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    }
  ],
  "check_status_effect_and_delete_single_connected_id": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "target_status_effect_value",
      "ref": false
    }
  ],
  "check_uuid": [
    {
      "name": "uuid",
      "ref": false
    }
  ],
  "computed_value": [
    {
      "name": "item_arr",
      "ref": false
    },
    {
      "name": "bucket_name",
      "ref": false
    },
    {
      "name": "key",
      "ref": false
    }
  ],
  "creature_body_vanishes_active": [
    {
      "name": "item_arr",
      "ref": false
    }
  ],
  "creature_payload_statuses": [
    {
      "name": "arr",
      "ref": false
    },
    {
      "name": "owner_state_resolver",
      "ref": false,
      "default": null
    }
  ],
  "creature_statuses": [
    {
      "name": "arr",
      "ref": false
    },
    {
      "name": "mode",
      "ref": false,
      "default": "target"
    }
  ],
  "destroy_creature": [
    {
      "name": "target_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "discern_variable_tags": [
    {
      "name": "variable",
      "ref": false
    },
    {
      "name": "item_arr",
      "ref": false
    },
    {
      "name": "x_substitute",
      "ref": false,
      "default": null
    }
  ],
  "display_warning": [
    {
      "name": "message",
      "ref": false
    }
  ],
  "drop_target_equipped_in_hand_inventory": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    }
  ],
  "encounter_creature_field": [
    {
      "name": "arr",
      "ref": false
    },
    {
      "name": "key",
      "ref": false
    }
  ],
  "encounter_field": [
    {
      "name": "encounter_arr",
      "ref": false
    },
    {
      "name": "key",
      "ref": false
    }
  ],
  "encounter_read_creature": [
    {
      "name": "encounter_arr",
      "ref": false
    },
    {
      "name": "encounter_creature_id",
      "ref": false
    }
  ],
  "error_log": [],
  "extract_encounter_creature_arrs_to_encounter_creature_surface_arr": [
    {
      "name": "item_arr",
      "ref": true
    }
  ],
  "fetch_encounter_creatures": [
    {
      "name": "filters",
      "ref": false,
      "default": []
    },
    {
      "name": "visited_ids",
      "ref": false,
      "default": []
    }
  ],
  "fetch_statuses": [
    {
      "name": "filters",
      "ref": false,
      "default": []
    },
    {
      "name": "visited_ids",
      "ref": false,
      "default": []
    }
  ],
  "finalize_creature_arr": [
    {
      "name": "item_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "defer_pl",
      "ref": false,
      "default": false
    }
  ],
  "fire_target_loses_status_effect_triggers": [
    {
      "name": "removed_status_item_id",
      "ref": false
    },
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    }
  ],
  "ft_bake_castable_into_blob": [
    {
      "name": "item_arr",
      "ref": true
    }
  ],
  "ft_campaign_clock_to_minutes": [
    {
      "name": "campaign_arr",
      "ref": false
    }
  ],
  "ft_campaign_context": [
    {
      "name": "creature_arr",
      "ref": false
    },
    {
      "name": "campaign_arr",
      "ref": false,
      "default": null
    }
  ],
  "ft_campaign_light_for_clock": [
    {
      "name": "campaign_arr",
      "ref": false
    }
  ],
  "ft_campaign_season_transition_minutes_base": [
    {
      "name": "seasonRow",
      "ref": false
    }
  ],
  "ft_campaign_sun_transition_minutes": [
    {
      "name": "campaign_arr",
      "ref": false
    }
  ],
  "ft_combat_truth_contingencies_shape": [
    {
      "name": "c",
      "ref": false
    }
  ],
  "ft_combat_truth_member_scalars": [
    {
      "name": "db",
      "ref": false
    },
    {
      "name": "eid",
      "ref": false
    },
    {
      "name": "id",
      "ref": false
    }
  ],
  "ft_combat_truth_snapshot": [
    {
      "name": "db",
      "ref": false
    },
    {
      "name": "eid",
      "ref": false
    },
    {
      "name": "member_ids",
      "ref": false
    }
  ],
  "ft_combat_truth_status_entry": [
    {
      "name": "row",
      "ref": false
    },
    {
      "name": "with_definition",
      "ref": false
    }
  ],
  "ft_combat_truth_verdict_shape": [
    {
      "name": "v",
      "ref": false
    }
  ],
  "ft_contingency_arm_authorize": [
    {
      "name": "caster_arr",
      "ref": false
    },
    {
      "name": "spell_id",
      "ref": false
    },
    {
      "name": "cond",
      "ref": false
    },
    {
      "name": "cast_level",
      "ref": false,
      "default": null
    },
    {
      "name": "arming_item_id",
      "ref": false,
      "default": "DC9778C6-5B9B-1501-B86A-5EEF4671F66A"
    }
  ],
  "ft_contingency_claim_status": [
    {
      "name": "status_id",
      "ref": false
    }
  ],
  "ft_contingency_parse_condition": [
    {
      "name": "packed",
      "ref": false
    }
  ],
  "ft_contingency_refund_mana": [
    {
      "name": "caster_ec",
      "ref": false
    },
    {
      "name": "amount",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "ft_corpse_body_world_position": [
    {
      "name": "corpse_arr",
      "ref": false
    },
    {
      "name": "encounter_id",
      "ref": false
    }
  ],
  "ft_corpse_consume_body": [
    {
      "name": "creature_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "ft_corpse_inventory_for_creature": [
    {
      "name": "encounter_creature_id",
      "ref": false
    }
  ],
  "ft_corpse_publish_creature_position": [
    {
      "name": "ec_id",
      "ref": false
    },
    {
      "name": "encounter_id",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "ft_corpse_sync_creature_row": [
    {
      "name": "ec_id",
      "ref": false
    },
    {
      "name": "encounter_id",
      "ref": false
    },
    {
      "name": "x",
      "ref": false
    },
    {
      "name": "y",
      "ref": false
    },
    {
      "name": "z",
      "ref": false
    }
  ],
  "ft_creature_matches_active_combat": [
    {
      "name": "creature_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    }
  ],
  "ft_ec_mark_derived_refresh_dirty": [
    {
      "name": "encounter_creature_id",
      "ref": false
    },
    {
      "name": "origin",
      "ref": false,
      "default": "other"
    }
  ],
  "ft_enc_pos_sidecar_write_encounter": [
    {
      "name": "encounter_id",
      "ref": false
    },
    {
      "name": "scalars",
      "ref": false
    }
  ],
  "ft_encounter_context": [
    {
      "name": "creature_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    }
  ],
  "ft_encounter_context_for_write": [
    {
      "name": "creature_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    }
  ],
  "ft_encounter_id_is_depth_authored": [
    {
      "name": "encounter_id",
      "ref": false
    }
  ],
  "ft_encounter_roster_row_ref": [
    {
      "name": "encounter_arr",
      "ref": true
    },
    {
      "name": "id",
      "ref": false
    }
  ],
  "ft_entry_restore_item_arr": [
    {
      "name": "entry",
      "ref": false
    }
  ],
  "ft_fetch_all_active_contingency_triggers_for_encounter": [
    {
      "name": "encounter_id",
      "ref": false
    }
  ],
  "ft_fetch_meshes_for": [
    {
      "name": "attached_id",
      "ref": false
    }
  ],
  "ft_finalize_item_arr_post": [
    {
      "name": "item_arr",
      "ref": true
    },
    {
      "name": "ancestor_ids",
      "ref": false,
      "default": []
    },
    {
      "name": "dedupe_and_lean",
      "ref": false,
      "default": true
    }
  ],
  "ft_ground_collision_diameter_ft": [
    {
      "name": "row",
      "ref": false
    }
  ],
  "ft_inc_action_patch_after_row_write": [
    {
      "name": "ec_id",
      "ref": false
    },
    {
      "name": "encounter_id",
      "ref": false
    },
    {
      "name": "cols",
      "ref": false
    },
    {
      "name": "ops",
      "ref": false
    }
  ],
  "ft_inc_move_patch_after_row_write": [
    {
      "name": "ec_id",
      "ref": false
    },
    {
      "name": "encounter_id",
      "ref": false
    },
    {
      "name": "cols",
      "ref": false
    }
  ],
  "ft_layer_entry_needs_resolve": [
    {
      "name": "v",
      "ref": false
    }
  ],
  "ft_lean_status_entry": [
    {
      "name": "entry",
      "ref": false
    }
  ],
  "ft_legacy_hit": [
    {
      "name": "unit",
      "ref": false
    },
    {
      "name": "truth",
      "ref": false,
      "default": false
    }
  ],
  "ft_meshes_compile_enabled": [],
  "ft_normalize_combat_id": [
    {
      "name": "value",
      "ref": false
    }
  ],
  "ft_normalize_layer_entries_to_distinct_uuids": [
    {
      "name": "entries",
      "ref": false
    }
  ],
  "ft_opportunity_attack_client_input": [
    {
      "name": "actor",
      "ref": false
    }
  ],
  "ft_perm_encounter_for": [
    {
      "name": "item_arr",
      "ref": false
    }
  ],
  "ft_reseed_vitality_from_authority": [
    {
      "name": "arr",
      "ref": true
    }
  ],
  "ft_resolve_layer_entry": [
    {
      "name": "entry",
      "ref": false
    },
    {
      "name": "root",
      "ref": false
    }
  ],
  "ft_skip_server_rule": [
    {
      "name": "reason",
      "ref": false
    },
    {
      "name": "actor_arr",
      "ref": false
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "campaign_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "target_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "status_item_id",
      "ref": false,
      "default": null
    }
  ],
  "ft_spell_is_level_upcastable": [
    {
      "name": "ability_arr",
      "ref": false
    }
  ],
  "ft_status_item_passive_entries": [
    {
      "name": "carrier",
      "ref": false
    },
    {
      "name": "dedup_by_passive_id",
      "ref": false,
      "default": true
    }
  ],
  "ft_status_target_unset": [
    {
      "name": "arr",
      "ref": true
    },
    {
      "name": "key",
      "ref": false
    }
  ],
  "ft_status_trigger_listeners_shape": [
    {
      "name": "rows",
      "ref": false
    }
  ],
  "ft_swarm_shed": [
    {
      "name": "target_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "final",
      "ref": false
    }
  ],
  "ft_trap_apply_rearm_timer": [
    {
      "name": "host_arr",
      "ref": true
    },
    {
      "name": "trap_ability_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": true
    },
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    }
  ],
  "ft_trap_arm": [
    {
      "name": "host_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "campaign_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "encounter_arr",
      "ref": true,
      "default": null
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    },
    {
      "name": "log_message",
      "ref": false,
      "default": false
    },
    {
      "name": "carry_noticed",
      "ref": false,
      "default": false
    }
  ],
  "ft_trap_armed_status_row": [
    {
      "name": "host_arr",
      "ref": false
    }
  ],
  "ft_trap_consume_armed_state": [
    {
      "name": "host_arr",
      "ref": true
    },
    {
      "name": "encounter_arr",
      "ref": true
    },
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    }
  ],
  "ft_trap_fire_payload_interaction_matches": [
    {
      "name": "host_arr",
      "ref": false
    },
    {
      "name": "interaction",
      "ref": false
    }
  ],
  "ft_trap_is_armed": [
    {
      "name": "host_arr",
      "ref": false
    }
  ],
  "ft_trap_mounted_ability_ids": [
    {
      "name": "host_arr",
      "ref": false
    }
  ],
  "ft_trap_place_zone": [
    {
      "name": "host_arr",
      "ref": true
    },
    {
      "name": "trap_ability_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": true
    },
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    }
  ],
  "ft_trap_remove_zones": [
    {
      "name": "host_arr",
      "ref": true
    },
    {
      "name": "trap_ability_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": true
    },
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    }
  ],
  "ft_trap_reset_interval_arr": [
    {
      "name": "reset",
      "ref": false
    },
    {
      "name": "trap_ability_arr",
      "ref": false
    }
  ],
  "ft_trap_reset_is_timed": [
    {
      "name": "reset",
      "ref": false
    }
  ],
  "ft_trap_status_row_ends_sortable": [
    {
      "name": "row",
      "ref": false
    }
  ],
  "ft_trap_timed_trigger_not_fired": [
    {
      "name": "host_inventory_id",
      "ref": false
    },
    {
      "name": "trap_ability_id",
      "ref": false
    }
  ],
  "ft_trap_try_lazy_timed_resolution": [
    {
      "name": "host_arr",
      "ref": true
    },
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    }
  ],
  "ft_trapped_status_id": [],
  "get_encounter_creature_arr": [
    {
      "name": "encounter_creature_id",
      "ref": false
    }
  ],
  "get_encounter_creature_permissions": [
    {
      "name": "item_arr",
      "ref": true
    }
  ],
  "get_inventory_arr": [
    {
      "name": "inventory_id",
      "ref": false
    },
    {
      "name": "visited_ids",
      "ref": false,
      "default": []
    }
  ],
  "get_status_effect_duration_times": [
    {
      "name": "caster_arr",
      "ref": false
    },
    {
      "name": "item_id_used_arr",
      "ref": false
    },
    {
      "name": "use_ability_variable_1",
      "ref": false,
      "default": null
    }
  ],
  "handle_summon_tag_status_effect": [
    {
      "name": "status_id",
      "ref": false
    },
    {
      "name": "status_connected_id",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "has_status_effect": [
    {
      "name": "arr",
      "ref": false
    },
    {
      "name": "status_item_id",
      "ref": false
    }
  ],
  "insert_log_message": [
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "roll_type_1",
      "ref": false
    },
    {
      "name": "roll_item_id",
      "ref": false
    },
    {
      "name": "item_id_used_arr",
      "ref": false
    },
    {
      "name": "roll_by_arr",
      "ref": false
    },
    {
      "name": "roll_to_arr",
      "ref": false
    },
    {
      "name": "roll_result",
      "ref": false,
      "default": null
    },
    {
      "name": "roll_private",
      "ref": false,
      "default": 0
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "campaign_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "location_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "secret_visible_to_creator",
      "ref": false,
      "default": false
    },
    {
      "name": "voice",
      "ref": false,
      "default": false
    }
  ],
  "insert_massive_damage_instant_death_log_message": [
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "item_id_used_arr",
      "ref": false
    },
    {
      "name": "target_arr",
      "ref": false
    }
  ],
  "inventory_field": [
    {
      "name": "inventory_arr",
      "ref": false
    },
    {
      "name": "key",
      "ref": false
    }
  ],
  "is_animated_summon": [
    {
      "name": "target_arr",
      "ref": false
    }
  ],
  "is_creature_not_a_summon": [
    {
      "name": "target_arr",
      "ref": false
    }
  ],
  "is_target_encounter_format": [
    {
      "name": "str",
      "ref": false
    }
  ],
  "item_field": [
    {
      "name": "item_arr",
      "ref": false
    },
    {
      "name": "key",
      "ref": false
    }
  ],
  "janus_attack_ability_context_arr": [
    {
      "name": "item_id_used_arr",
      "ref": false
    }
  ],
  "janus_nested_attack_ability_overlaps_passive_add_charges": [
    {
      "name": "item_id_used_arr",
      "ref": false
    },
    {
      "name": "passive_ability_arr",
      "ref": false
    }
  ],
  "janus_trigger_auto_place_aoe": [
    {
      "name": "owner_arr",
      "ref": false
    },
    {
      "name": "inciting_target_arr",
      "ref": false
    },
    {
      "name": "ability_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    }
  ],
  "janus_trigger_carrier_entries": [
    {
      "name": "caster_arr",
      "ref": false
    },
    {
      "name": "carrier",
      "ref": false
    }
  ],
  "janus_trigger_carriers": [],
  "k4ActiveCombatColumn": [],
  "k4CombatsTable": [],
  "kill_creature": [
    {
      "name": "encounter_creature_arr",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "layer_entries": [
    {
      "name": "item_arr",
      "ref": false
    },
    {
      "name": "layer_name",
      "ref": false
    },
    {
      "name": "visited",
      "ref": false,
      "default": []
    }
  ],
  "layer_has": [
    {
      "name": "item_arr",
      "ref": false
    },
    {
      "name": "layer_name",
      "ref": false
    }
  ],
  "layer_list_entry_uuid": [
    {
      "name": "entry",
      "ref": false
    }
  ],
  "layer_value": [
    {
      "name": "item_arr",
      "ref": false
    },
    {
      "name": "layer_name",
      "ref": false
    },
    {
      "name": "visited",
      "ref": false,
      "default": []
    }
  ],
  "log_consciousness": [
    {
      "name": "target_arr",
      "ref": false
    },
    {
      "name": "roll_id",
      "ref": false
    }
  ],
  "lost_shapeshift": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    },
    {
      "name": "custom_message",
      "ref": false,
      "default": "lost_shapeshift"
    },
    {
      "name": "nested_status",
      "ref": false,
      "default": false
    }
  ],
  "ordinal": [
    {
      "name": "number",
      "ref": false
    }
  ],
  "passive_ability_entry_is_active": [
    {
      "name": "entry",
      "ref": false
    }
  ],
  "pl_cost_layer_entry_uuid": [
    {
      "name": "entry",
      "ref": false
    }
  ],
  "pl_total": [
    {
      "name": "item_arr",
      "ref": false
    }
  ],
  "pos_coord": [
    {
      "name": "arr",
      "ref": false
    },
    {
      "name": "coord",
      "ref": false
    }
  ],
  "process_affected_ids": [
    {
      "name": "affected_structured",
      "ref": false
    },
    {
      "name": "extra_options",
      "ref": false,
      "default": []
    }
  ],
  "process_dynamic_layers": [
    {
      "name": "status_effect_value",
      "ref": false
    },
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "process_int_layer_types",
      "ref": false,
      "default": true
    }
  ],
  "publishToRedis": [],
  "query_charges": [
    {
      "name": "charge_holder",
      "ref": false
    },
    {
      "name": "item_id",
      "ref": false
    },
    {
      "name": "default_charges",
      "ref": false
    }
  ],
  "query_d_item_arr": [
    {
      "name": "item_id",
      "ref": false
    },
    {
      "name": "source_error",
      "ref": false,
      "default": ""
    },
    {
      "name": "affected_ids",
      "ref": false,
      "default": []
    },
    {
      "name": "forced_item_type",
      "ref": false,
      "default": null
    }
  ],
  "query_encounter_arr": [
    {
      "name": "encounter_id",
      "ref": false
    },
    {
      "name": "debug_variable_name",
      "ref": false,
      "default": null
    }
  ],
  "query_encounter_creature_arr": [
    {
      "name": "item_id",
      "ref": false
    }
  ],
  "query_full_item_arr": [
    {
      "name": "item_id",
      "ref": false
    },
    {
      "name": "debug_variable_name",
      "ref": false,
      "default": null
    },
    {
      "name": "creature_preview_skip_finalize",
      "ref": false,
      "default": false
    },
    {
      "name": "suppress_missing_item_warning",
      "ref": false,
      "default": false
    },
    {
      "name": "ancestor_ids",
      "ref": false,
      "default": []
    },
    {
      "name": "cache_only",
      "ref": false,
      "default": false
    }
  ],
  "query_player_character_arr": [
    {
      "name": "item_id",
      "ref": false
    }
  ],
  "register_shutdown_function": [],
  "remove_recovery_and_dying_states": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "remove_stackable_status_effect_item_id_single_connection": [
    {
      "name": "status_caster_id",
      "ref": false
    },
    {
      "name": "status_caster_arr",
      "ref": false
    },
    {
      "name": "status_target_id",
      "ref": false
    },
    {
      "name": "status_target_arr",
      "ref": false
    },
    {
      "name": "status_casting_targets_arr",
      "ref": false
    },
    {
      "name": "status_origin_id",
      "ref": false
    },
    {
      "name": "status_item_id",
      "ref": false
    },
    {
      "name": "status_ends",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    }
  ],
  "remove_status_effect_item_id_single_connection": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "status_item_id",
      "ref": false
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "preserve_connected_peers",
      "ref": false,
      "default": false
    }
  ],
  "remove_status_effect_status_id_all_connections_to_all_targets": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "status_id",
      "ref": false
    },
    {
      "name": "roll_id",
      "ref": false,
      "default": null
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    },
    {
      "name": "campaign_arr",
      "ref": false,
      "default": null
    }
  ],
  "remove_status_effects": [
    {
      "name": "item_id_used_arr",
      "ref": false
    },
    {
      "name": "item_layer_type_name",
      "ref": false
    },
    {
      "name": "caster_arr",
      "ref": true
    },
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "roll_id",
      "ref": false
    },
    {
      "name": "status_connected_id",
      "ref": true,
      "default": null
    },
    {
      "name": "encounter_arr",
      "ref": false,
      "default": null
    }
  ],
  "search_encounter_arr_for_item_arr": [
    {
      "name": "encounter_arr",
      "ref": false
    },
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "item_id",
      "ref": false
    }
  ],
  "set_pos_coord": [
    {
      "name": "arr",
      "ref": true
    },
    {
      "name": "coord",
      "ref": false
    },
    {
      "name": "value",
      "ref": false
    }
  ],
  "set_roll_by_arr_to_campaign_gm": [
    {
      "name": "campaign_arr",
      "ref": false
    },
    {
      "name": "encounter_arr",
      "ref": false
    }
  ],
  "soft_delete_encounter_creature": [
    {
      "name": "target_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "departed_alive",
      "ref": false,
      "default": false
    }
  ],
  "update_campaign_and_encounters_light": [
    {
      "name": "campaign_arr",
      "ref": true
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "new_light",
      "ref": false
    },
    {
      "name": "campaign_sun_state",
      "ref": false
    },
    {
      "name": "extra_campaign_updates",
      "ref": false,
      "default": []
    }
  ],
  "update_encounter_creature_stats": [
    {
      "name": "encounter_creature_arr",
      "ref": true
    },
    {
      "name": "updates",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true,
      "default": []
    }
  ],
  "update_inventory_stats": [
    {
      "name": "inventory_arr",
      "ref": false
    },
    {
      "name": "updates",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    },
    {
      "name": "affected_inventory_changed",
      "ref": false,
      "default": []
    },
    {
      "name": "affected_possessor_changed",
      "ref": false,
      "default": []
    }
  ],
  "update_status_effect_stats": [
    {
      "name": "status_effect_arr",
      "ref": false
    },
    {
      "name": "updates",
      "ref": false
    },
    {
      "name": "affected_ids",
      "ref": true
    }
  ],
  "v_status_id_of": [
    {
      "name": "item_arr",
      "ref": false
    }
  ],
  "valid_uuid": [
    {
      "name": "uuid",
      "ref": false
    },
    {
      "name": "variable_name",
      "ref": false,
      "default": "UUID"
    }
  ]
};
export interface DispatchDeps {
    "FateTideRedis::redis_ephemeral_set_json"(...args: unknown[]): unknown;
    "FateTideRedis::redis_get"(...args: unknown[]): unknown;
    "FateTideRedis::redis_invalidate"(...args: unknown[]): unknown;
    "FateTideRedis::redis_set"(...args: unknown[]): unknown;
    "Skill::getVariableName"(itemId: unknown): unknown;
    "StatusEffect::getQuantityInfo"(itemId: unknown): unknown;
    "StatusEffect::resolveQuantityAlias"(itemId: unknown): unknown;
    "ability_entry_current_charges"(entry: unknown, caster_arr: unknown, arg2?: unknown): unknown;
    "ability_entry_id"(entry: unknown): unknown;
    "add_charges_to_ability"(used_ability_arr: unknown, caster_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id: unknown, use_ability_variable_1?: unknown): unknown;
    "adjust_charges"(caster_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, item_id: unknown, adjust_charge_qty: unknown, roll_id?: unknown, log_message?: unknown, actual_debit?: PhpRef<unknown>): unknown;
    "advance_turn_if_dying_creatures_turn"(dying_creature_arr: unknown, affected_ids: PhpRef<unknown>): unknown;
    "apply_death_effect"(caster_arr: unknown, target_arr: unknown, affected_ids: PhpRef<unknown>, roll_id: unknown, status_connected_id: unknown, custom_message?: unknown, item_id_used?: unknown, body_vanishes?: unknown): unknown;
    "apply_maimed_status"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id: unknown): unknown;
    "apply_persistent_aoe_to_encounter"(item_id_used_arr: unknown, caster_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id: unknown, status_connected_id: PhpRef<unknown>, encounter_arr: PhpRef<unknown>, campaign_arr: unknown, status_casting_targets_arr: PhpRef<unknown>, use_ability_variable_1?: unknown, continue_use_ability_logic?: unknown, spell_counterspelled?: unknown, paoe_follows_carrier_id?: PhpRef<unknown>): unknown;
    "apply_status_effect"(status_connected_id: unknown, status_caster_arr: unknown, status_target_arr: PhpRef<unknown>, status_casting_targets_arr: unknown, affected_ids: PhpRef<unknown>, status_origin_id: unknown, status_item_id: unknown, status_ends: unknown, roll_id?: unknown, log_message?: unknown, unique_log_message?: unknown, status_private?: unknown, log_overlay_item_id_used_arr?: unknown, status_aoe_source?: unknown, status_opposing_team_only?: unknown, status_paused_campaign?: unknown, has_duration?: unknown, bypass_immunity?: unknown, campaign_arr?: unknown, encounter_arr?: unknown, status_shapeshift_monster_template_id?: unknown, allow_duplicate_status_item_id?: unknown, suppress_status_side_effects?: unknown, status_stack?: unknown, status_aoe_geometry?: unknown): unknown;
    "campaign_arr_has_active_house_rule_type"(campaign_arr: unknown, campaign_house_rule_type_id: unknown): unknown;
    "campaign_field"(campaign_arr: unknown, key: unknown): unknown;
    "campaign_time_to_seconds"(campaign_time: unknown): unknown;
    "change_inventory_charges"(inventory_arr: unknown, caster_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, change_charges_to: unknown, log_message?: unknown): unknown;
    "check_ability_conditions"(ability_arr: unknown, item_arr: unknown, template_creature?: unknown, defer_skill_tier_requirements?: unknown): unknown;
    "check_other_status_effect_specials"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, target_status_effect_value: unknown, roll_id: unknown, encounter_arr?: unknown): unknown;
    "check_status_effect_and_delete_single_connected_id"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, target_status_effect_value: unknown): unknown;
    "check_uuid"(uuid: unknown): unknown;
    "computed_value"(item_arr: unknown, bucket_name: unknown, key: unknown): unknown;
    "creature_body_vanishes_active"(item_arr: unknown): unknown;
    "creature_payload_statuses"(arr: unknown, owner_state_resolver?: unknown): unknown;
    "creature_statuses"(arr: unknown, mode?: unknown): unknown;
    "destroy_creature"(target_arr: unknown, affected_ids: PhpRef<unknown>): unknown;
    "discern_variable_tags"(variable: unknown, item_arr: unknown, x_substitute?: unknown): unknown;
    "display_warning"(message: unknown): unknown;
    "drop_target_equipped_in_hand_inventory"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id: unknown): unknown;
    "encounter_creature_field"(arr: unknown, key: unknown): unknown;
    "encounter_field"(encounter_arr: unknown, key: unknown): unknown;
    "encounter_read_creature"(encounter_arr: unknown, encounter_creature_id: unknown): unknown;
    "error_log"(...args: unknown[]): unknown;
    "extract_encounter_creature_arrs_to_encounter_creature_surface_arr"(item_arr: PhpRef<unknown>): unknown;
    "fetch_encounter_creatures"(filters?: unknown, visited_ids?: unknown): unknown;
    "fetch_statuses"(filters?: unknown, visited_ids?: unknown): unknown;
    "finalize_creature_arr"(item_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, defer_pl?: unknown): unknown;
    "fire_target_loses_status_effect_triggers"(removed_status_item_id: unknown, target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id: unknown, encounter_arr?: unknown): unknown;
    "ft_bake_castable_into_blob"(item_arr: PhpRef<unknown>): unknown;
    "ft_campaign_clock_to_minutes"(campaign_arr: unknown): unknown;
    "ft_campaign_context"(creature_arr: unknown, campaign_arr?: unknown): unknown;
    "ft_campaign_light_for_clock"(campaign_arr: unknown): unknown;
    "ft_campaign_season_transition_minutes_base"(seasonRow: unknown): unknown;
    "ft_campaign_sun_transition_minutes"(campaign_arr: unknown): unknown;
    "ft_combat_truth_contingencies_shape"(c: unknown): unknown;
    "ft_combat_truth_member_scalars"(db: unknown, eid: unknown, id: unknown): unknown;
    "ft_combat_truth_snapshot"(db: unknown, eid: unknown, member_ids: unknown): unknown;
    "ft_combat_truth_status_entry"(row: unknown, with_definition: unknown): unknown;
    "ft_combat_truth_verdict_shape"(v: unknown): unknown;
    "ft_contingency_arm_authorize"(caster_arr: unknown, spell_id: unknown, cond: unknown, cast_level?: unknown, arming_item_id?: unknown): unknown;
    "ft_contingency_claim_status"(status_id: unknown): unknown;
    "ft_contingency_parse_condition"(packed: unknown): unknown;
    "ft_contingency_refund_mana"(caster_ec: unknown, amount: unknown, affected_ids: PhpRef<unknown>): unknown;
    "ft_corpse_body_world_position"(corpse_arr: unknown, encounter_id: unknown): unknown;
    "ft_corpse_consume_body"(creature_arr: unknown, affected_ids: PhpRef<unknown>): unknown;
    "ft_corpse_inventory_for_creature"(encounter_creature_id: unknown): unknown;
    "ft_corpse_publish_creature_position"(ec_id: unknown, encounter_id: unknown, affected_ids: PhpRef<unknown>): unknown;
    "ft_corpse_sync_creature_row"(ec_id: unknown, encounter_id: unknown, x: unknown, y: unknown, z: unknown): unknown;
    "ft_creature_matches_active_combat"(creature_arr: unknown, encounter_arr?: unknown): unknown;
    "ft_ec_mark_derived_refresh_dirty"(encounter_creature_id: unknown, origin?: unknown): unknown;
    "ft_enc_pos_sidecar_write_encounter"(encounter_id: unknown, scalars: unknown): unknown;
    "ft_encounter_context"(creature_arr: unknown, encounter_arr?: unknown): unknown;
    "ft_encounter_context_for_write"(creature_arr: unknown, encounter_arr?: unknown): unknown;
    "ft_encounter_id_is_depth_authored"(encounter_id: unknown): unknown;
    "ft_encounter_roster_row_ref"(encounter_arr: PhpRef<unknown>, id: unknown): unknown;
    "ft_entry_restore_item_arr"(entry: unknown): unknown;
    "ft_fetch_all_active_contingency_triggers_for_encounter"(encounter_id: unknown): unknown;
    "ft_fetch_meshes_for"(attached_id: unknown): unknown;
    "ft_finalize_item_arr_post"(item_arr: PhpRef<unknown>, ancestor_ids?: unknown, dedupe_and_lean?: unknown): unknown;
    "ft_ground_collision_diameter_ft"(row: unknown): unknown;
    "ft_inc_action_patch_after_row_write"(ec_id: unknown, encounter_id: unknown, cols: unknown, ops: unknown): unknown;
    "ft_inc_move_patch_after_row_write"(ec_id: unknown, encounter_id: unknown, cols: unknown): unknown;
    "ft_layer_entry_needs_resolve"(v: unknown): unknown;
    "ft_lean_status_entry"(entry: unknown): unknown;
    "ft_legacy_hit"(unit: unknown, truth?: unknown): unknown;
    "ft_meshes_compile_enabled"(): unknown;
    "ft_normalize_combat_id"(value: unknown): unknown;
    "ft_normalize_layer_entries_to_distinct_uuids"(entries: unknown): unknown;
    "ft_opportunity_attack_client_input"(actor: unknown): unknown;
    "ft_perm_encounter_for"(item_arr: unknown): unknown;
    "ft_reseed_vitality_from_authority"(arr: PhpRef<unknown>): unknown;
    "ft_resolve_layer_entry"(entry: unknown, root: unknown): unknown;
    "ft_skip_server_rule"(reason: unknown, actor_arr: unknown, roll_id?: unknown, encounter_arr?: unknown, campaign_arr?: unknown, target_arr?: unknown, status_item_id?: unknown): unknown;
    "ft_spell_is_level_upcastable"(ability_arr: unknown): unknown;
    "ft_status_item_passive_entries"(carrier: unknown, dedup_by_passive_id?: unknown): unknown;
    "ft_status_target_unset"(arr: PhpRef<unknown>, key: unknown): unknown;
    "ft_status_trigger_listeners_shape"(rows: unknown): unknown;
    "ft_swarm_shed"(target_arr: unknown, affected_ids: PhpRef<unknown>, roll_id: unknown, final: unknown): unknown;
    "ft_trap_apply_rearm_timer"(host_arr: PhpRef<unknown>, trap_ability_arr: unknown, encounter_arr: PhpRef<unknown>, campaign_arr: unknown, affected_ids: PhpRef<unknown>, roll_id: unknown): unknown;
    "ft_trap_arm"(host_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, campaign_arr?: unknown, encounter_arr?: PhpRef<unknown>, roll_id?: unknown, log_message?: unknown, carry_noticed?: unknown): unknown;
    "ft_trap_armed_status_row"(host_arr: unknown): unknown;
    "ft_trap_consume_armed_state"(host_arr: PhpRef<unknown>, encounter_arr: PhpRef<unknown>, campaign_arr: unknown, affected_ids: PhpRef<unknown>, roll_id: unknown): unknown;
    "ft_trap_fire_payload_interaction_matches"(host_arr: unknown, interaction: unknown): unknown;
    "ft_trap_is_armed"(host_arr: unknown): unknown;
    "ft_trap_mounted_ability_ids"(host_arr: unknown): unknown;
    "ft_trap_place_zone"(host_arr: PhpRef<unknown>, trap_ability_arr: unknown, encounter_arr: PhpRef<unknown>, campaign_arr: unknown, affected_ids: PhpRef<unknown>, roll_id?: unknown): unknown;
    "ft_trap_remove_zones"(host_arr: PhpRef<unknown>, trap_ability_arr: unknown, encounter_arr: PhpRef<unknown>, campaign_arr: unknown, affected_ids: PhpRef<unknown>, roll_id: unknown): unknown;
    "ft_trap_reset_interval_arr"(reset: unknown, trap_ability_arr: unknown): unknown;
    "ft_trap_reset_is_timed"(reset: unknown): unknown;
    "ft_trap_status_row_ends_sortable"(row: unknown): unknown;
    "ft_trap_timed_trigger_not_fired"(host_inventory_id: unknown, trap_ability_id: unknown): unknown;
    "ft_trap_try_lazy_timed_resolution"(host_arr: PhpRef<unknown>, campaign_arr: unknown, encounter_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id?: unknown): unknown;
    "ft_trapped_status_id"(): unknown;
    "get_encounter_creature_arr"(encounter_creature_id: unknown): unknown;
    "get_encounter_creature_permissions"(item_arr: PhpRef<unknown>): unknown;
    "get_inventory_arr"(inventory_id: unknown, visited_ids?: unknown): unknown;
    "get_status_effect_duration_times"(caster_arr: unknown, item_id_used_arr: unknown, use_ability_variable_1?: unknown): unknown;
    "handle_summon_tag_status_effect"(status_id: unknown, status_connected_id: unknown, affected_ids: PhpRef<unknown>): unknown;
    "has_status_effect"(arr: unknown, status_item_id: unknown): unknown;
    "insert_log_message"(roll_id: unknown, roll_type_1: unknown, roll_item_id: unknown, item_id_used_arr: unknown, roll_by_arr: unknown, roll_to_arr: unknown, roll_result?: unknown, roll_private?: unknown, encounter_arr?: unknown, campaign_arr?: unknown, location_arr?: unknown, secret_visible_to_creator?: unknown, voice?: unknown): unknown;
    "insert_massive_damage_instant_death_log_message"(roll_id: unknown, item_id_used_arr: unknown, target_arr: unknown): unknown;
    "inventory_field"(inventory_arr: unknown, key: unknown): unknown;
    "is_animated_summon"(target_arr: unknown): unknown;
    "is_creature_not_a_summon"(target_arr: unknown): unknown;
    "is_target_encounter_format"(str: unknown): unknown;
    "item_field"(item_arr: unknown, key: unknown): unknown;
    "janus_attack_ability_context_arr"(item_id_used_arr: unknown): unknown;
    "janus_nested_attack_ability_overlaps_passive_add_charges"(item_id_used_arr: unknown, passive_ability_arr: unknown): unknown;
    "janus_trigger_auto_place_aoe"(owner_arr: unknown, inciting_target_arr: unknown, ability_arr: unknown, encounter_arr?: unknown): unknown;
    "janus_trigger_carrier_entries"(caster_arr: unknown, carrier: unknown): unknown;
    "janus_trigger_carriers"(): unknown;
    "k4ActiveCombatColumn"(): unknown;
    "k4CombatsTable"(): unknown;
    "kill_creature"(encounter_creature_arr: unknown, affected_ids: PhpRef<unknown>): unknown;
    "layer_entries"(item_arr: unknown, layer_name: unknown, visited?: unknown): unknown;
    "layer_has"(item_arr: unknown, layer_name: unknown): unknown;
    "layer_list_entry_uuid"(entry: unknown): unknown;
    "layer_value"(item_arr: unknown, layer_name: unknown, visited?: unknown): unknown;
    "log_consciousness"(target_arr: unknown, roll_id: unknown): unknown;
    "lost_shapeshift"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id?: unknown, custom_message?: unknown, nested_status?: unknown): unknown;
    "ordinal"(number: unknown): unknown;
    "passive_ability_entry_is_active"(entry: unknown): unknown;
    "pl_cost_layer_entry_uuid"(entry: unknown): unknown;
    "pl_total"(item_arr: unknown): unknown;
    "pos_coord"(arr: unknown, coord: unknown): unknown;
    "process_affected_ids"(affected_structured: unknown, extra_options?: unknown): unknown;
    "process_dynamic_layers"(status_effect_value: unknown, target_arr: PhpRef<unknown>, process_int_layer_types?: unknown): unknown;
    "publishToRedis"(...args: unknown[]): unknown;
    "query_charges"(charge_holder: unknown, item_id: unknown, default_charges: unknown): unknown;
    "query_d_item_arr"(item_id: unknown, source_error?: unknown, affected_ids?: unknown, forced_item_type?: unknown): unknown;
    "query_encounter_arr"(encounter_id: unknown, debug_variable_name?: unknown): unknown;
    "query_encounter_creature_arr"(item_id: unknown): unknown;
    "query_full_item_arr"(item_id: unknown, debug_variable_name?: unknown, creature_preview_skip_finalize?: unknown, suppress_missing_item_warning?: unknown, ancestor_ids?: unknown, cache_only?: unknown): unknown;
    "query_player_character_arr"(item_id: unknown): unknown;
    "register_shutdown_function"(...args: unknown[]): unknown;
    "remove_recovery_and_dying_states"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>): unknown;
    "remove_stackable_status_effect_item_id_single_connection"(status_caster_id: unknown, status_caster_arr: unknown, status_target_id: unknown, status_target_arr: unknown, status_casting_targets_arr: unknown, status_origin_id: unknown, status_item_id: unknown, status_ends: unknown, affected_ids: PhpRef<unknown>, roll_id?: unknown): unknown;
    "remove_status_effect_item_id_single_connection"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, status_item_id: unknown, roll_id?: unknown, encounter_arr?: unknown, preserve_connected_peers?: unknown): unknown;
    "remove_status_effect_status_id_all_connections_to_all_targets"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, status_id: unknown, roll_id?: unknown, encounter_arr?: unknown, campaign_arr?: unknown): unknown;
    "remove_status_effects"(item_id_used_arr: unknown, item_layer_type_name: unknown, caster_arr: PhpRef<unknown>, target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, roll_id: unknown, status_connected_id?: PhpRef<unknown>, encounter_arr?: unknown): unknown;
    "search_encounter_arr_for_item_arr"(encounter_arr: unknown, campaign_arr: unknown, item_id: unknown): unknown;
    "set_pos_coord"(arr: PhpRef<unknown>, coord: unknown, value: unknown): unknown;
    "set_roll_by_arr_to_campaign_gm"(campaign_arr: unknown, encounter_arr: unknown): unknown;
    "soft_delete_encounter_creature"(target_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, departed_alive?: unknown): unknown;
    "update_campaign_and_encounters_light"(campaign_arr: PhpRef<unknown>, affected_ids: PhpRef<unknown>, new_light: unknown, campaign_sun_state: unknown, extra_campaign_updates?: unknown): unknown;
    "update_encounter_creature_stats"(encounter_creature_arr: PhpRef<unknown>, updates: unknown, affected_ids?: PhpRef<unknown>): unknown;
    "update_inventory_stats"(inventory_arr: unknown, updates: unknown, affected_ids: PhpRef<unknown>, affected_inventory_changed?: unknown, affected_possessor_changed?: unknown): unknown;
    "update_status_effect_stats"(status_effect_arr: unknown, updates: unknown, affected_ids: PhpRef<unknown>): unknown;
    "v_status_id_of"(item_arr: unknown): unknown;
    "valid_uuid"(uuid: unknown, variable_name?: unknown): unknown;
}
